import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getVerottajailmoitettavaProjectIds = async ({
  apiPath,
  activeEmployerInfo = {},
  isLocalApiRequest = false,
}) => {
  const signedRequest = await createSignedGetRequest({
    apiPath,
    activeEmployerInfo,
    isLocalApiRequest,
  });

  const response = await axios(signedRequest);

  return response.data;
};
